import React from "react";
import { View } from "react-native-web";

export const MarginBottom = ({ size }) => (
  <View style={{ marginBottom: size }} />
);
